<template>
  <div class="act-marquee" :style="wrapStyle">
    <transition name="fade">
      <div v-for="(item,index) in records" :key="index" v-if="index === current_show" v-html="item">
      </div>
    </transition>
  </div>
</template>
<script>
  import click_handler from '../../tools/mgtv/click'
  import handler_action from '../../tools/mgtv/action'
  import {toRem} from '../../tools/tpl'
  import {getJSON, getJSONP} from "../../api/myaxios";
  import {isString, isObject} from '../../tools/typeof'
  import {onUseInfoLoad} from '../../tools/onUseInfoLoad'
  import {isArray} from '../../tools/typeof'
  import {toInt} from '../../tools/toInt'

  function render_tpl(tpl, data, style = "") {
    if (!isString(tpl)) {
      return ''
    }
    if (!isObject(data)) {
      return tpl
    }
    if (!tpl) {
      tpl = '';
    }

    console.log('render_tpl', tpl, data);

    for (const key in data) {
      const v = data[key] + '';
      const regex = new RegExp('\\$\\{' + key + '\\}', "g");
      if (isString(key) && isString(v)) {
        tpl = tpl.replace(regex, v)
      }
    }

    return `<div class='item' style="${style}">${tpl}</div>`;
  }


  export default {
    name: 'ActMarquee',
    props: ['info'],

    data() {
      return {
        api: this.info.mq_data_source_api,
        custom_text: this.info.mq_data_source_t,
        remote_data: null,
        current_show: 0,
        interval: null
      }
    },
    methods: {
      init() {

        //this.info.mq_data_source 外部数据源，
        if (!this.info.mq_data_source_api && this.info.mq_data_source_inner && this.info.mq_data_source_inner !== 'none') {
          switch (this.info.mq_data_source_inner) {
            case 'lottery':
              this.api = '//vipact3.api.mgtv.com/api/v1/act/lot/award/lamp?act_name=${ACT_NAME}&offset=0&count=20';
              if (!this.custom_text) {
                this.custom_text = '恭喜${nickname}获得了${name}'
              }
              break;
            default:
              break;
          }

          return;
        }


      },
      getDataFromRemote() {
        let api = this.api;
        console.log('getDataFromRemote', api)
        if (!api) {
          return;
        }
        const must_login = api.indexOf('${TICKET}') !== -1;
        onUseInfoLoad(() => {
          const ticket = window.$bus.user.ticket || '';
          let real_api = api.replace('${TICKET}', ticket).replace('${ACT_NAME}', window.rootdata.act_name);
          if (real_api.indexOf('?') === -1) {
            real_api += ('?t=' + new Date().getTime())
          } else {
            real_api += ('&t=' + new Date().getTime())
          }
          console.log('getDataFromRemote', real_api)

          getJSONP(real_api).then(res => {
            if (!res) {
              return;
            }
            if (res.ret === 0) {
              this.remote_data = res.data;
              return;
            }

          })
        }, must_login);
      },
      startShow() {
        if (!this.records || this.records.length === 0) {
          return
        }
        window.clearInterval(this.interval);
        this.interval = null;
        this.current_show = 0;
        const len = this.records.length;
        if (len === 0) {
          return;
        }
        const speed = toInt(this.info.mq_speed);
        if(speed > 0){
          this.interval = setInterval(() => {
            this.current_show = (this.current_show + 1) % len;
          }, speed);
        }


      },
      stopShow() {
        window.clearInterval(this.current_show);
      }
    },

    watch: {
      records(val) { //当获取到remote_data时重新开始展示
        this.stopShow();
        this.startShow();
      }
    },
    computed: {
      wrapStyle() {
        const css = {
          ...this.info.css,
          'over-flow': 'hidden'
        };

        if (this.info.mq_bg) {
          css.background = `url('${this.info.mq_bg}') no-repeat`
          css.backgroundSize = `100% 100%`
        }
        return css
      },

      style() {
        const css = {
          'font-size': toRem(this.info.mq_font_size),
          'color': this.info.mq_color,
          'width': this.info.css.width,
          'height': this.info.css.height,
          'line-height': this.info.css.height
        };
        let res = '';
        for (const k in css) {
          res += `${k}:${css[k]};`
        }
        return res
      },
      records() {
        let content = [];
        //如果有远程数据
        if (this.remote_data && this.remote_data.list) {
          //如果远程数据是一个list，则输出多行文本
          this.remote_data.list.forEach((item, index) => {
            item['INDEX'] = (index + 1); //提供一个INDEX属性
            content.push(render_tpl(this.custom_text, item, this.style))
          })
          return content;
        } else {
          //单纯的文本
          if (!this.info.mq_t) {
            return content;
          }
          const texts = this.info.mq_t.split('\n');
          texts.forEach(item => {
            content.push(render_tpl(item, {}, this.style));
          });
          return content
        }
      },
    },
    mounted() {
      this.init();
      this.startShow();
      this.getDataFromRemote();
    },
    destroyed() {
      this.stopShow();
    }
  }
</script>


<style lang="stylus">

  @import "../../share/mixins.styl"
  .act-marquee
    position relative
    overflow hidden
    .item
      padding 0 .1rem
      top 0
      left 0
      position absolute
      text-align center
      width 7.5rem
      ellipsis()

    .fade-enter-active {
      transition: all .5s;
    }

    .fade-leave-active {
      transition all .5s;
    }

    .fade-enter {
      transform translate(0, 2rem)
    }

    .fade-leave-to /* .fade-leave-active below version 2.1.8 */
    {
      transform translate(0, -2rem)
    }
</style>













// WEBPACK FOOTER //
// src/components/ConfigUI/ActMarquee.vue